import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { useMatch } from 'react-router';

import { documentTitleAtom } from '@/caregiverSpace/shared/model';

export const TitleDecorator = ({
    title,
    path,
    children,
}: React.PropsWithChildren<{
    title: string;
    path: string;
}>) => {
    const match = useMatch(path);
    const documentTitle = useAtomValue(documentTitleAtom);
    useEffect(() => {
        if (!match) {
            return;
        }
        document.title = documentTitle ?? title;
    }, [match, documentTitle, title]);
    return <>{children}</>;
};
